import React from 'react';


const ReturnIcon = () => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="54px" height="54px" viewBox="0 0 54 54" enableBackground="new 0 0 54 54" xmlSpace="preserve">  <image id="image0" width="54" height="54" x="0" y="0"
    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
  AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAJ
  MklEQVRo3tWaf4wU5RnHP887s7t33O1V4QRRgcod/ZHUFpVUW0GJiYmSFm2b2hQVf2D1n7bxTvTQ
  pv2zkaStJv2r/mqrNVb5o0ATbWkaPPFHIEEBaVrkPEHvOE5ACnfHwe7MPP1j3pmd3dvbH3eHR7+b
  yc7uzLzv85nnmXee94c80PEwUygHWAxcA3wV+CIwD5gFNNtzhoFjwMfAPuA94A1gF+DXW+Hjv1lf
  9n93CmAEWAbcCdwCzKxyfrPdFgBLE/9/CmwE/ghsA3QyRplJXJsG7gN6gG7gnhqgKmmmLaMb2G/L
  Tn+WYGIN+AD4HbCw+KD9iEHEYMbZouPR+SVqs2V/YOuS6mYVq95QbAd+TyKEYqPE7okgIohE9wBE
  iu1SjaJMUQ1/i2oYe/aY/XUJ8Axwt916zgbY94GngZYYyMKIiWCM/S7eyklVy2xB+B1oeFNUI8Cl
  wE7gXmDDVIEZYD2wtgjIbsYYjAhijN03ZUBLoRgDEmhAEARoEBAYDffDEyPAFuBl4FdAFxBMBswh
  bKVuKwfkOE4IE2/h7zFeK/VWGY8FQUAQ+PY73HzfLwe4FrgIWE2F10MlMAGejaBEBDGCMU4M5DjR
  fgGwNAQrhWJpSBagfHzfxxiTAPTRILwriq6yUHcyzmuhEtgvBVlN7CHBMQ6O68ZA5aDKwZRrPJL/
  JSFDMAfHCeEiQN8TfPEJgth7dyjaDzxSzvjxmvtbBVlHBOQ4uG6KVCpNKpUmnU7b/RSuBY3AyoXi
  mFAoOZ68NqzLJZVKldSVxnVTtq6o4ZJ1HZ1dP6gVrF2QpyIoYxIVpVMWJgQq90xNVKWgUb3hDU3W
  HdUbwz3Z0dnVXg1MLFRL6Cm36O5FQEkPTRaoGmDkwULERDa4EVyLIE91dHYVGVEEJsgqRJaPhUqR
  cl17t84OUDVA13VJJewpgVsuyG3jgTUist4kWr4IzHVcTImXSpVOp/nud77Fmntup6UlO+WAxhiM
  4+A6ro0eN9F4CYis7+jsahwDJsgaEbm46JkqgYoqKge1cuWNzJ07h4aGDJlMZsq9ByTgnCLPGeMg
  IhcJsqYITBARkQcKLWAY07V6auXKG5kz+wIAul9/iyNHjk4p2HieK37mBRHp6OxcJwWPiVwrRtoc
  E11gT054qpzKQe3d++8phypVBBc7wXFxjIMYWYjItQDGZhWrjQlBHNfBcUKwStnDdEElbQqTBDe0
  uRCSqwGko3OdGGMGU6nUBalUinS68CKs1PKt+uH3OP/886bE2NHRUfr6BujtPUDvhwcJgqDqNVEa
  5vs+npcnl8uRz+fJ5/NHgyCY7YrIV4wxFxSS2srPVKRstrlq5bWqsbGRRYsWsmjRQoaGhtm27W0+
  PPBRTZ6LXuaO40TpV6uqXuaKyPJC7ufiOKam99OmzX/j5pU34rouuVyeHTt2MjQ0XBdQtiVLtrmJ
  fN5j/vxLmD27lWy2mRUrbmDXrvd4860dVcsIQ9IQBC6OE/cOlrvGmCuSXZBkZ7GSDh8eZOOmV1j5
  7ZtIp1MsWbKYjZte4dix4xPy2vYdO5k7dw7XLvsmra0zWbz4MkSEN97cXtVrIibOUqzXLneWLb1u
  reu68wv5X21gACMjp+jvP0R7+0IymQzt7Zfy0Ud9jI6enhDc8PAI+/b1MGvWTM4/73NceOFsjh07
  zvHj/63p+qh3oEEwbMSYS5KdxXpTpcHBI2z+66vkcnkaGhq45eYVNDXNmBAYgOd5bNmylSNHjwGw
  bOnVOBVeOcWJs2Uw5mJjjGlNNhgTUSlcNju5lMrzPLq73wKgubmJtvZLq16T7BUYY1pcI6a5Uiex
  HriXN2wk29zM4cODkwILy/uEgYFB5s6dQ1vbpbz//gcVoaLOqx13yZrCwMvks/UTJ07S139o0lCR
  Dh78GCBOAiqpqPNqBCMiw2e7CzJRnTw5BFDzM5uAGzIi5ui5CAXgB3XPUUTDfkNGRPrOVY81NTUB
  cOZMrg4oQUT6jAg9kjhwLmnevIsBOGqb/mpQCfUY4N3pBiinbHMz8y3YgSp5YxEgIMK7BnhtuiHK
  6ZprrsJxHPJ5j//sq3kuIlK3IZxRnPou7yS0ZMnltLV9HoCd7+zi9OnaUzQNWfYYDWdyNkNyemd6
  lMmkuf76ZVz19SsA6Os/xDvv7KkNqGD75l/8vEtd22F7TlXvqafxyGTS5HJ5XNcl8H3ECCAEQYDr
  OuRyeWbMaCTwg2gqaIyMMTQ0NNDUNIMFC+bx5S8tigeCBgYGefXVf9Z1syMWANdO5bxOOHvYVmsh
  9665g+eef4kVN93A7j17aW2dRSaT5sPegyxdejUvvfwX7r5rVd1eU1V27d7L9u078f2632O9loXI
  Y6qqTwC/rduSKdLIyCl6ew+we8+/OHHi5ITKUNUnfvbogxqCBfE0zjOq+oiIXFRLIRs3vcKpU6Ns
  fW0bw8MjDAwMYoxhdPQ0f9+ylXzeY8s/tnL69JlxxzBmzGgkn/c4cuQoIyOnJnVjVPWQqj4d/Xbj
  mUTVUaBLVZ+v5Vnr7x8A4JNPogZ1ND4WtWL79/dOytg6oAC61nU9EBthkjOJqvoC5+h7rYq6re2x
  jCamRoMgUFW9T1UnFuTTIFU9qao/evihnxY1nyYomf9V1WjxyP+L7n9o7U/2l/5pxk5kB6jqS6r6
  2HRbXE2q+tjaB3/853LHTDSaGm4evh9ED+OjwJ+m2/gKesHaWFYmOVsfzc7bkFRVvQt4cboJyuhF
  Vb1TK6QlhsQYeDgO7iXXV/iqejvw6+kmSehxVb1dVf1KY/xGidZY+Pieh+9FIelHIRmo6lrgVmA6
  W8uTwK2q2mltqphyhSORdtmPH/h4vlfwmvWc1QbgSsJFk5+13rB1bwDCR8dGWEWwgtc0DkfPy+P5
  Xgxn064e4DpgDdD/GQD127quU9WeuD3wIwfkK4MVw4Vgdq4Jr8RzqhoQLkVqA+4Hzkbe1GvLbgOe
  tXUmoPzYvqpg1mqCQOO1TCFgrpznAM4ATwKLgOXAHwiXv05Un9oyltsynwTOFK2zsp7K53Px4zKe
  itZSKYoohM7xIg9FzDiq8XRTJBEJCJe7dhOulrsS+AbwNeALhIudZxKuA84TLnY+DgwA7wO7gbcJ
  1yPGlpauryq02qGnovfuePofnIfSY7Q0LOcAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjEtMDQtMjRU
  MTU6NDY6MzErMDM6MDD1eyGJAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIxLTA0LTI0VDE1OjQ2OjMx
  KzAzOjAwhCaZNQAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAAASUVORK5C
  YII=" />
  </svg>
);

export default ReturnIcon;
